The institution the person attended.
